/** Built-in expense categories. Users may also type a custom value. */
export const EXPENSE_CATEGORIES = [
  "Software & subscriptions",
  "Advertising & marketing",
  "Travel & accommodation",
  "Equipment & hardware",
  "Professional services",
  "Office & admin",
  "Training & development",
  "Contractor & freelancer",
  "Phone & internet",
  "Bank charges & fees",
  "Other",
];
